import http from "./http-common";
class ProfilDataService {
    getAll(limit) {
        return http.get(`/get-data-profil?limit=${limit}`);
      }

}
export default new ProfilDataService();